import Breadcrumb from "./Breadcrumb";
import CustomCard from "./CustomCard";
import { DynamicDateTimePicker } from "./DynamicDateTimePicker";
import CustomLabelSwitch from "./LabelSwitch";
import CustomModal from "./Modal";
import CustomMultiselect from "./Multiselect";
import PageTitle from "./PageTitle";
import CustomRadio from "./Radio";
import CustomSelect from "./Select";
import CustomSwitch from "./Switch";
import { showToast, SuccessIcon, ErrorIcon } from "./Toast";
import CustomToolTip from "./ToolTip";
import Tab from "./Tab";
import ColorPicker from "./ColorPicker";
import FileDropzone from "./FileDropzone";
import ColorSwatchPicker from "./ColorSwatchPicker";
import CustomChart from "./CustomChart";
import LabeledValue from "./LabeledValue";
import ThemeColorSelect from "./ThemeColorSelect";

export const ExtendedComponents = {
  dynamicDateTimePicker: DynamicDateTimePicker,
  customLabelSwitch: CustomLabelSwitch,
  customModal: CustomModal,
  customMultiselect: CustomMultiselect,
  pageTitle: PageTitle,
  customRadio: CustomRadio,
  customSelect: CustomSelect,
  customSwitch: CustomSwitch,
  customCard: CustomCard,
  showToast: showToast,
  successIcon: SuccessIcon,
  errorIcon: ErrorIcon,
  customTooltip: CustomToolTip,
  breadcrumb: Breadcrumb,
  tab: Tab,
  colorPicker: ColorPicker,
  fileDropzone: FileDropzone,
  customChart: CustomChart,
  colorSwatchPicker: ColorSwatchPicker,
  labeledValue: LabeledValue,
  themeColorSelect: ThemeColorSelect,
};
